// extracted by mini-css-extract-plugin
export default {"badge-round":"BadgeRound_badge-round__yf1Uv"};